import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { MISC, API } from '@const'
import * as utils from '@utils'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, MenuItem } from '@material-ui/core'
import { TextField } from '@prototype'
import { withStyles } from '@material-ui/styles'
import { green } from '@material-ui/core/colors'


class tigerBoard extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'TigerBoard', options)
        }
        this.state = {
            dialogOpen: false,
            type: '',
            eventID: 0,
            magnification: '',
            isSend: false,
            account: '',
            accountList: MISC.EVENT_FAKEACCOUNT_LIST,
            gameCode: '',
            gameList: [],
            valid: false,
            continue: false,
            addList: [],
            isLoading: true
        }
    }

    componentDidMount() {
      const { eventID, type, detail, gameList } = this.props.options
      const init = {
        eventID,
        type,
        account: this.state.accountList[0],
        gameList,
        gameCode: gameList[0]
      }
      
      if (type === 'edit') {
        init.account = detail.account
        init.magnification = detail.magnification
        init.gameCode = detail.gameCode
      }
      this.setState({
        ...init,
        dialogOpen: true,
        isLoading: false
      })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
        this.props.closeDialog()
    }

    /** 新增/修改送出 */
    handleSubmit(callbackType) {
        /** callbackType => continue: 送出帳號確認後繼新增 */
        this.setState({
            isLoading: true,
            valid: true,
            continue: callbackType === 'continue'
        })
        if (this.handleMagnificationValid() === false) {
            this.setState({
                isLoading: false
            })
            return false 
        }

        const params = {
            "event_id": this.state.eventID,
            "account_prefix": this.state.account,
            "threshold": Number(this.state.magnification),
            "game_code": this.state.gameCode
        }

        utils.apiRequest(
            'post',
            API.FAKEACCOUNT_TIGER,
            params,
            (data) => {
                /** 新增狀態切換帳號列表 */
                if (this.state.type === 'add') {
                    this.setState({
                        isLoading: false,
                        addList: data,
                        isSend: true
                    })
                } else {
                    this.handleConfirm()
                }
            },
            (err) => {
                if (err.code !== 300150) {
                    this.setState({
                        isLoading: false
                    })
                }
            }
        )
    }

    /** 新增帳號列表 => 確認 */
    handleConfirm() {
        this.props.queryData()
        if (this.state.continue === false) {
            this.closeDialog()
        } else {
            this.setState({
                // account: this.state.accountList[0],
                // gameCode: this.state.gameList[0],
                // magnification: '',
                isLoading: false,
                isSend: false,
                valid: false,
                continue: false
            })
        }
    }

    /** 注單倍率驗證 */
    handleMagnificationValid() {
        if (this.state.magnification === '' || Number(this.state.magnification) === 0) {
            return false
        }
        if (this.state.type === 'edit' && Number(this.state.magnification) < Number(this.props.options.detail.magnification)) {
            return false
        }
        return true
    }

    /** 注單倍率錯誤訊息 */
    magnificationErrorMsg() {
        if (this.state.magnification === '' || Number(this.state.magnification) === 0) {
            return this.t('magnificationRequired')
        } else if (this.state.type === 'edit' && Number(this.state.magnification) < Number(this.props.options.detail.magnification)) {
            return this.t('magnificationValid')
        }
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} fullWidth maxWidth="xs" disableEscapeKeyDown={true}>
                <DialogTitle>{this.state.isSend ? this.t('view') : this.state.type === 'add'? this.t('add'):this.t('edit')}</DialogTitle>
                <DialogContent>
                    {!this.state.isSend && 
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    {this.state.type === 'add' && <TextField
                                        className={this.props.classes.formControl}
                                        select
                                        label={this.state.type === 'add'? this.t('fakeAccountPrefix'):this.t('fakeAccount')}
                                        value={this.state.account}
                                        onChange={(event) =>
                                            this.setState({
                                                account: event.target.value,
                                            })
                                        }
                                        disabled={this.state.type === 'edit'}
                                    >
                                        {this.state.accountList.map(item => (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        ))}
                                    </TextField>}
                                    {this.state.type === 'edit' && <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('fakeAccount')}
                                        value={this.state.account}
                                        disabled={true}
                                    />}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.formControl}
                                        select
                                        label={this.t('gameName')}
                                        value={this.state.gameCode}
                                        onChange={(event) =>
                                            this.setState({
                                                gameCode: event.target.value,
                                            })
                                        }
                                        disabled={this.state.type === 'edit'}
                                    >
                                        {this.state.gameList.map(item => (
                                            <MenuItem key={item} value={item}>{utils.getGameName(item)}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('magnification')}
                                        value={this.state.magnification}
                                        required={true}
                                        error={this.state.valid && !this.handleMagnificationValid()}
                                        helperText={this.state.valid && !this.handleMagnificationValid() ? this.magnificationErrorMsg() : ''}
                                        onChange={(event) => {
                                            this.setState({
                                                magnification: utils.clearNoNum(event.target.value, false, false)
                                            })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {this.state.isSend && 
                        <Grid container spacing={2}>
                            <Grid item xs={12} className={this.props.classes.addListHeader}>
                                {this.t('accountBeenAdd', {value: this.state.addList.length})}
                            </Grid>
                            <Grid item xs={12} className={this.props.classes.addListContent}>
                                {this.state.addList.map(account => (
                                    <span key={account}>
                                        {account}
                                    </span>
                                ))}
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    {(this.state.type === 'add' && !this.state.isSend) && 
                        <>
                            <Button variant="contained" onClick={() => this.closeDialog()} color="secondary" disabled={this.state.isLoading}>
                                {this.t('cancel')}
                            </Button>
                            <Button variant="contained" onClick={() => this.handleSubmit()} color="primary" disabled={this.state.isLoading}>
                                {this.t('closeAfterAdd')}
                            </Button>
                            <GreenButton variant="contained" onClick={() => this.handleSubmit('continue')} color="primary" disabled={this.state.isLoading}>
                                {this.t('continueAfterAdd')}
                            </GreenButton>
                        </>
                    }
                    {this.state.isSend && 
                        <Button variant="contained" onClick={() => this.handleConfirm()} color="primary">
                            {this.t('confirm')}
                        </Button>
                    }
                    {this.state.type === 'edit' && 
                        <>
                            <Button variant="contained" onClick={() => this.closeDialog()} color="secondary" disabled={this.state.isLoading}>
                                {this.t('cancel')}
                            </Button>
                            <Button variant="contained" onClick={() => this.handleSubmit()} color="primary" disabled={this.state.isLoading}>
                                {this.t('save')}
                            </Button>
                        </>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        addListHeader: {
            textAlign: 'center',
            fontSize: 15,
            color: '#69131c'
        },
        addListContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            '& span': {
                width: '100%',
                textAlign: 'center'
            }
        }
    }
}

const GreenButton = withStyles(() => ({
    root: {
      color: '#ffffff',
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
}))(Button);

tigerBoard.propTypes = {
    classes: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
    options: PropTypes.object,
    queryData: PropTypes.func,
}

export default hoc(styles)(tigerBoard)
